/**
 * Sticky CTA — shows a fixed bar when the CTA soin block scrolls out of viewport.
 */
import { Component } from '@theme/component';

class StickyCta extends Component {
  #observer = null;

  connectedCallback() {
    super.connectedCallback();

    const trigger = document.querySelector('[data-sticky-cta-trigger]');
    if (!trigger) return;

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.classList.add('tw:translate-y-full');
          this.setAttribute('aria-hidden', 'true');
          this.inert = true;
        } else {
          this.classList.remove('tw:translate-y-full');
          this.removeAttribute('aria-hidden');
          this.inert = false;
        }
      },
      { threshold: 0 }
    );
    this.#observer.observe(trigger);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }
}

if (!customElements.get('sticky-cta')) {
  customElements.define('sticky-cta', StickyCta);
}
